var FullyFittedLandingJS = (function ($) {
    'use strict';

    var INTENT_MAIL_ORDER = 'MAIL_ORDER';
    var INTENT_FULLY_FITTED = 'FULLY_FITTED';
    var SELECTED_PARTNER_POSTCODE_KEY = 'fullyFittedLandingSelectedPartnerPostcode';

    function readRootValue($root, attrName, defaultValue) {
        var value = $root.attr(attrName);
        return (value !== undefined && value !== null && value !== '') ? value : defaultValue;
    }

    function readRootBool($root, attrName, defaultValue) {
        var raw = readRootValue($root, attrName, null);
        if (raw === null) {
            return defaultValue;
        }
        return raw === true || raw === 'true' || raw === '1';
    }

    function readRootInt($root, attrName, defaultValue) {
        var raw = readRootValue($root, attrName, null);
        if (raw === null) {
            return defaultValue;
        }
        var value = parseInt(raw, 10);
        return isNaN(value) ? defaultValue : value;
    }

    function readCsrf($root) {
        var $csrf = $root.find('.fully-fitted-landing-csrf').first();
        return {
            token: $csrf.val(),
            header: $csrf.attr('data-header') || 'X-CSRF-TOKEN'
        };
    }

    function getIntent($root) {
        var $toggle = $root.find('[data-ffl-toggle]').first();
        if ($toggle.length) {
            return $toggle.is(':checked') ? INTENT_FULLY_FITTED : INTENT_MAIL_ORDER;
        }
        var $checked = $root.find('[data-ffl-intent-radio]:checked').first();
        if ($checked.length) {
            return $checked.val();
        }
        $checked = $root.find('input[name="fullyFittedLandingIntent"]:checked');
        if ($checked.length) {
            return $checked.val();
        }
        var $select = $root.find('[data-ffl-intent-select], #fullyFittedLandingIntentSelect').first();
        if ($select.length) {
            return $select.val();
        }
        return INTENT_MAIL_ORDER;
    }

    function setIntent($root, intent) {
        var $toggle = $root.find('[data-ffl-toggle]').first();
        if ($toggle.length) {
            $toggle.prop('checked', intent === INTENT_FULLY_FITTED);
        }
        var $radio = $root.find('[data-ffl-intent-radio][value="' + intent + '"], input[name="fullyFittedLandingIntent"][value="' + intent + '"]').first();
        if ($radio.length) {
            $radio.prop('checked', true);
        }
        var $select = $root.find('[data-ffl-intent-select], #fullyFittedLandingIntentSelect').first();
        if ($select.length) {
            $select.val(intent);
        }
    }

    function updateInfoVisibility($root, intent) {
        var $info = $root.find('[data-ffl-info]');
        if (!$info.length) {
            return;
        }
        $info.hide();
        $info.filter('[data-ffl-info="' + intent + '"]').show();
    }

    function showError($root, message) {
        var $err = $root.find('[data-ffl-error]').first();
        if (!$err.length) {
            return;
        }
        $err.text(message || '').toggle(!!message);
    }

    function isSearchForm($form) {
        if ($form.is('[data-ffl-search-form]') || $form.hasClass('j-fully-fitted-landing-search-form')) {
            return true;
        }

        var action = ($form.attr('action') || '').toLowerCase();
        var method = ($form.attr('method') || 'get').toLowerCase();
        return method === 'get' && action.indexOf('/search') !== -1;
    }

    function persistIntention($root, payload) {
        var url = readRootValue($root, 'data-intention-url', '/fully-fitted/intention');
        var csrf = readCsrf($root);

        return $.ajax({
            url: url,
            type: 'POST',
            data: payload,
            beforeSend: function (xhr) {
                if (csrf && csrf.token) {
                    xhr.setRequestHeader(csrf.header, csrf.token);
                }
                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            }
        });
    }

    function readSelectedFullyFittedPartnerId() {
        try {
            var raw = window.localStorage ? window.localStorage.getItem('selectedServicePartnerData') : null;
            if (!raw) {
                return null;
            }

            var parsed = JSON.parse(raw);
            if (!parsed || !parsed.partnerId) {
                return null;
            }

            return parsed.partnerId;
        } catch (e) {
            return null;
        }
    }

    function normalizePostcode(postcode) {
        return (postcode || '').replace(/\s+/g, '').toUpperCase();
    }

    function readSelectedPartnerPostcode() {
        try {
            return window.localStorage ? window.localStorage.getItem(SELECTED_PARTNER_POSTCODE_KEY) : null;
        } catch (e) {
            return null;
        }
    }

    function storeSelectedPartnerPostcode(postcode) {
        try {
            if (!window.localStorage) {
                return;
            }
            window.localStorage.setItem(SELECTED_PARTNER_POSTCODE_KEY, normalizePostcode(postcode));
        } catch (e) {
        }
    }

    function clearSelectedPartnerPostcode() {
        try {
            if (window.localStorage) {
                window.localStorage.removeItem(SELECTED_PARTNER_POSTCODE_KEY);
            }
        } catch (e) {
        }
    }

    function clearSelectedPartnerState($form) {
        try {
            if (window.localStorage) {
                window.localStorage.removeItem('selectedServicePartnerData');
            }
        } catch (e) {
        }
        clearSelectedPartnerPostcode();
        if ($form && $form.length) {
            $form.find('input[name="fullyFittedPartnerId"]').remove();
        }
    }

    function hasPartnerForPostcode(postcode) {
        var partnerId = readSelectedFullyFittedPartnerId();
        if (!partnerId) {
            return false;
        }

        return normalizePostcode(postcode) === normalizePostcode(readSelectedPartnerPostcode());
    }

    function syncSelectedPartnerField($form, intent) {
        var fieldName = 'fullyFittedPartnerId';
        var $field = $form.find('input[name="' + fieldName + '"]').first();
        if (intent !== INTENT_FULLY_FITTED) {
            $field.remove();
            return;
        }

        var partnerId = readSelectedFullyFittedPartnerId();
        if (!partnerId) {
            $field.remove();
            return;
        }

        if (!$field.length) {
            $field = $('<input>', {
                type: 'hidden',
                name: fieldName
            }).appendTo($form);
        }
        $field.val(partnerId);
    }

    function getVehicleTypeFilter($form) {
        var vehicleType = $form.find('input[name="vehicleTypes"]').first().val();
        return vehicleType || 'PKW';
    }

    function getSearchForms($root) {
        var targetSelector = readRootValue($root, 'data-ffl-target-forms', '');
        if (targetSelector) {
            return $(targetSelector).filter('form');
        }

        return $root.closest('form');
    }

    function openServicePartnerPopup($root, $form, postcode, radiusKm) {
        if (typeof ServicePartnerAddOn === 'undefined' || !ServicePartnerAddOn.searchForServicePartners) {
            return false;
        }

        var popupClosedWithoutSelection = true;
        var payload = {
            cityOrZipCode: postcode,
            radius: radiusKm,
            ignoreCartProducts: true,
            fullyFittedFlow: true,
            sort: 'PRICE',
            rimSizeHint: $form.find('#size').val() || $form.find('select[name="size"]').val() || '',
            spartnerFilters: getVehicleTypeFilter($form)
        };

        ServicePartnerAddOn.setRedirectAfterSelectedServicePartner(false);
        ServicePartnerAddOn.openInPopup();
        ServicePartnerAddOn.onClosePopup(function () {
            if (popupClosedWithoutSelection) {
                $form.data('fflSubmitting', false);
            }
        });
        ServicePartnerAddOn.onConfirmServicePartner(function (servicePartnerInformation, partnerId) {
            popupClosedWithoutSelection = false;
            if (partnerId) {
                var $field = $form.find('input[name="fullyFittedPartnerId"]').first();
                if (!$field.length) {
                    $field = $('<input>', {
                        type: 'hidden',
                        name: 'fullyFittedPartnerId'
                    }).appendTo($form);
                }
                $field.val(partnerId);
                storeSelectedPartnerPostcode(postcode);
            } else {
                syncSelectedPartnerField($form, INTENT_FULLY_FITTED);
            }
            $form.trigger('submit');
        });
        ServicePartnerAddOn.searchForServicePartners(payload);
        return true;
    }

    function bind($root) {
        var defaultRadiusKm = readRootInt($root, 'data-default-radius-km', 5);
        var initialIntent = readRootValue($root, 'data-selected-intent', INTENT_MAIL_ORDER);
        var invalidPostcodeMessage = readRootValue($root, 'data-invalid-postcode-message', 'Please enter a valid postcode.');
        var saveErrorMessage = readRootValue($root, 'data-save-error-message', 'Could not save your selection. Please try again.');
        var $postcode = $root.find('[data-ffl-postcode], #fullyFittedLandingPostcode').first();
        var $locationRow = $root.find('[data-ffl-location-row]').first();
        var $searchForms = getSearchForms($root);
        var persistedIntent = initialIntent === INTENT_FULLY_FITTED ? INTENT_FULLY_FITTED : INTENT_MAIL_ORDER;
        var selectedPartnerId = readSelectedFullyFittedPartnerId();
        var selectedPartnerPostcode = readSelectedPartnerPostcode();

        if (selectedPartnerId && selectedPartnerPostcode) {
            if (!$postcode.val()) {
                $postcode.val(selectedPartnerPostcode);
            }
            if (persistedIntent !== INTENT_FULLY_FITTED) {
                persistedIntent = INTENT_FULLY_FITTED;
            }
        }

        updateInfoVisibility($root, getIntent($root));

        function updateVisibility(intent) {
            var isFullyFitted = intent === INTENT_FULLY_FITTED;
            if ($locationRow.length) {
                $locationRow.toggle(isFullyFitted);
            }
            updateInfoVisibility($root, intent);
            if (!isFullyFitted) {
                showError($root, null);
            }
        }

        $root.on('change', '[data-ffl-toggle], [data-ffl-intent-radio], input[name="fullyFittedLandingIntent"], [data-ffl-intent-select], #fullyFittedLandingIntentSelect', function () {
            var intent = getIntent($root);
            updateVisibility(intent);

            if (intent === INTENT_MAIL_ORDER) {
                $root.data('fflReady', true);
                persistIntention($root, { deliveryIntent: INTENT_MAIL_ORDER }).done(function () {
                    $root.data('fflPersistedIntent', INTENT_MAIL_ORDER);
                });
                return;
            }

            if (($postcode.val() || '').trim().length >= 2) {
                $root.data('fflReady', true);
            } else {
                $root.data('fflReady', false);
                if ($postcode.length) {
                    $postcode.trigger('focus');
                }
            }
        });

        $root.on('input blur', '[data-ffl-postcode], #fullyFittedLandingPostcode', function () {
            if (getIntent($root) !== INTENT_FULLY_FITTED) {
                return;
            }
            if (!hasPartnerForPostcode($postcode.val())) {
                $searchForms.each(function () {
                    clearSelectedPartnerState($(this));
                });
            }
            if (($postcode.val() || '').trim().length >= 2) {
                showError($root, null);
            }
        });

        $searchForms.on('submit', function (e) {
            var $form = $(this);
            if (!isSearchForm($form)) {
                return;
            }

            var intent = getIntent($root);
            if (intent !== INTENT_FULLY_FITTED) {
                syncSelectedPartnerField($form, intent);
                return;
            }

            if ($form.data('fflSubmitting')) {
                syncSelectedPartnerField($form, intent);
                return;
            }

            var postcode = ($postcode.val() || '').trim();
            if (postcode.length < 2) {
                e.preventDefault();
                showError($root, invalidPostcodeMessage);
                if ($postcode.length) {
                    $postcode.trigger('focus');
                }
                return;
            }

            e.preventDefault();
            $form.data('fflSubmitting', true);
            showError($root, null);
            persistIntention($root, {
                deliveryIntent: INTENT_FULLY_FITTED,
                postcode: postcode,
                radiusKm: defaultRadiusKm
            }).done(function () {
                $root.data('fflPersistedIntent', INTENT_FULLY_FITTED);
                $root.data('fflReady', true);
                if (!hasPartnerForPostcode(postcode)) {
                    clearSelectedPartnerState($form);
                }
                syncSelectedPartnerField($form, INTENT_FULLY_FITTED);
                if (!hasPartnerForPostcode(postcode) && openServicePartnerPopup($root, $form, postcode, defaultRadiusKm)) {
                    return;
                }
                $form.trigger('submit');
            }).fail(function () {
                $root.data('fflReady', false);
                $form.data('fflSubmitting', false);
                showError($root, saveErrorMessage);
            });
        });

        $root.data('fflPersistedIntent', persistedIntent);
        $root.data('fflReady', persistedIntent !== INTENT_FULLY_FITTED || (($postcode.val() || '').trim().length >= 2));
        setIntent($root, persistedIntent);
        updateVisibility(persistedIntent);
    }

    function init() {
        $('[data-fully-fitted-landing-root]').each(function () {
            bind($(this));
        });
    }

    return {
        init: init
    };
})(jQuery);

jQuery(function () {
    FullyFittedLandingJS.init();
});

